// extracted by mini-css-extract-plugin
export default {"fieldset":"FormationInformation_fieldset__T2nqD","field":"FormationInformation_field__I3b7b","row":"FormationInformation_row__EtTFq","group":"FormationInformation_group__YBtUK"};